export default __webpack_public_path__ + "static/media/alert-circle.4f87cde6.svg";